/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2025) Takeda. All Rights Reserved
 */

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

type Props = {
  extraClassNames?: string;
  isExternal?: boolean;
  href: string;
  title: string;
};

export const VdzHeaderLink: FC<Props> = ({
  extraClassNames,
  isExternal = false,
  href,
  title,
}) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const link = isExternal ? t(href) : href;

  const selected = pathname === link;
  const className = `${baseClassName} ${extraClassNames}`;

  return link ? (
    <div className={`flex flex-col relative ${selected ? 'font-bold' : ''}`}>
      {isExternal ? (
        <a href={link} className={className} target="_blank" rel="noreferrer">
          {t(title)}
        </a>
      ) : (
        <Link to={link} className={className}>
          {t(title)}
        </Link>
      )}

      {selected ? (
        <div
          className="
            absolute
            mb-1 sm:mb-0
            bottom-0
            sm:bottom-6
            xl:bottom-4
            w-full
            border-b-4 sm:border-b-6 3xl:border-b-8
            border-white
            rounded"
        ></div>
      ) : null}
    </div>
  ) : null;
};

const baseClassName = `flex items-center min-h-9 sm:min-h-0 sm:py-8 text-md xl:text-xl text-center`;
